

/**
 * 
 */
(function navMenuServiceDefinition() {

    'use strict';

    angular.module('NavMenu')
        .service('navMenu', [
            '$rootScope', '$state',
            function navMenuService($rootScope, $state) {

                var menuItems = [];
                var userMenuItems = [];
                var observers = [];
                var hideSearchStates = {};

                this.LastIndex = -999;
                this.showSearch = true;

                $rootScope.$on('$stateChangeStart', function stateChanged(event, toState) {
                    this.showSearch = angular.isUndefined(hideSearchStates[toState.name]);
                    $rootScope.$broadcast('toggleSearchBar', this.showSearch);
                }.bind(this));

                this.hideSearchOn = function hideSearchOnState(states) {
                    if (!angular.isArray(states))
                        states = [states];

                    angular.forEach(states, function (state) {
                        hideSearchStates[state] = true;
                        if ($state.$current.name === state) {
                            this.showSearch = false;
                            $rootScope.$broadcast('toggleSearchBar', this.showSearch);
                        }
                    });
                };

                var changed = function navMenuServiceChanged() {
                    for (var i = 0; i < observers.length; i++)
                        observers[i]();
                };

                function applyConditions(items) {
                    var res = [];
                    angular.forEach(items, function (item) {
                        if (item.condition && !item.condition.apply(item, item))
                            return;

                        if (item.items) {
                            item = angular.copy(item);
                            item.items = applyConditions(item.items);
                        }
                        res.push(item);
                    });
                    return res;
                }

                this.update = function () {
                    changed();
                };

                this.getItems = function navMenuServiceGetItems() {
                    return applyConditions(menuItems);
                };

                this.getUserMenuItems = function navMenuServiceGetItems() {
                    return applyConditions(userMenuItems);
                };

                this.setUserMenuItems = function navMenuServiceSetUserItems(items) {

                    userMenuItems = items;
                    changed();

                }.bind(this);

                this.refresh = function refresh() {
                    changed();
                }.bind(this);

                this.setItems = function navMenuServiceSetItems(items) {

                    menuItems = items;
                    changed();

                }.bind(this);

                this.whenItemsChange = function (callback) {
                    observers.push(callback);
                };

                this.addItem = function navMenuServiceAddItem(item, index) {

                    if (index < 0) {
                        index = (menuItems.length + index) + 1;
                    }

                    if (angular.isArray(item)) {

                        for (var i = 0; i < item.length; i++) {
                            this.addItem(item[i], i);
                        }

                    } else {
                        var pos = menuItems.map(function (e) { return e.text; }).indexOf(item.text);
                        if (pos == -1) {
                            if (index !== undefined && index !== null && index !== this.LastIndex) {
                                menuItems.splice(index, 0, item);
                            } else {

                                menuItems.push(item);
                            }
                        }
                    }
                    changed();
                };

                this.removeItem = function navMenuServiceRemoveItem(index) {
                    if (index === this.LastIndex)
                        index = menuItems.length - 1;

                    menuItems.splice(index, 1);
                    changed();
                };

                this.clear = function clear() {
                    menuItems = [];
                    changed();
                };

                /* User Menu */
                this.addUserMenuItem = function addUserMenuItem(item, index) {

                    if (index < 0) {
                        index = (userMenuItems.length + index) + 1;
                    }

                    if (angular.isArray(item)) {

                        for (var i = 0; i < item.length; i++) {
                            this.addItem(item[i], i);
                        }

                    } else {
                        if (index !== undefined && index !== null && index !== this.LastIndex)
                            userMenuItems.splice(index, 0, item);
                        else
                            userMenuItems.push(item);
                    }
                    changed();
                };

                this.removeUserMenuItem = function removeUserMenuItem(index) {
                    if (index === this.LastIndex)
                        index = userMenuItems.length - 1;

                    userMenuItems.splice(index, 1);
                    changed();
                };
            }
        ]);
})();